export default __webpack_public_path__ + "static/media/3685.602acb4d.png";